<template>
  <section class="surface">
    <!-- Boton filtro mobile -->
    <v-container
      v-show="$vuetify.breakpoint.smAndDown && currentRoute === '/resultado'"
    >
      <v-expansion-panels class="my-2 transparent">
        <v-expansion-panel class="surface">
          <v-expansion-panel-header disable-icon-rotate flat>
            <template v-slot:actions>
              <v-icon color="transparent"> </v-icon>
            </template>
            <v-row no-gutters>
              <v-col cols="12">
                <h6 class="my-auto">Buscar Eventos</h6>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="container my-md-0 py-md-0 px-0 mx-0">
              <v-row
                no-gutters
                cols="12"
                justify-sm="space-around"
                justify-md="space-between"
                aling-md="center"
                class="flex-column flex-sm-row mt-md-2 mb-md-n3 mx-md-0"
              >
                <!-- Ciudad -->
                <v-col cols="12" md="4" sm="12">
                  <v-autocomplete
                    v-if="showSelectsFilter"
                    v-model="ciudadeseventosFilter"
                    :items="ciudadeseventos"
                    outlined
                    prepend-inner-icon="location_searching"
                    item-text="descripcion"
                    item-value="id"
                    multiple
                    small-chips
                    label="Ciudad"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip small v-if="index === 0">
                        <span>{{ item.descripcion }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption">
                        (+{{ ciudadeseventosFilter.length - 1 }} ciudades)
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- Fechas -->
                <v-col cols="12" md="3" sm="12">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :return-value.sync="desde"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    max-width="360"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="desde"
                        readonly
                        chips
                        small-chips
                        label="Rango de Fechas"
                        placeholder="Todas las fechas"
                        prepend-inner-icon="event"
                        outlined
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      header-color="primary"
                      v-model="desde"
                      show-adjacent-months
                      scrollable
                      full-width
                      locale="es-ES"
                      range
                    >
                      <v-spacer></v-spacer>
                      <v-card-actions>
                        <v-btn text large color="primary" @click="modal = false"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          text
                          large
                          color="primary"
                          @click="$refs.menu.save(desde)"
                          >OK</v-btn
                        >
                      </v-card-actions>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <!-- Barra de busqueda -->
                <v-col cols="12" md="3" sm="12">
                  <v-autocomplete
                    v-if="showSelectsFilter"
                    v-model="tiposEventosFilter"
                    :items="flatItems"
                    hide-details
                    outlined
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    item-text="nombre"
                    item-value="id"
                    placeholder="Buscar por artista o evento..."
                    label="Buscar por artista o evento..."
                  >
                    <!-- Slot para las selecciones -->
                    <template v-slot:selection="{ item, index }">
                      <v-chip :key="index" small @click:close="remove(item)">
                        {{ item.nombre }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- Boton de busqueda -->
                <v-col cols="12" md="2" sm="12">
                  <v-btn
                    block
                    rounded
                    class="primary font-weight-medium mt-4"
                    @click="filterEventos(1)"
                  >
                    Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <!-- Filtro Escritorio  Resultado-->
    <div
      v-if="$vuetify.breakpoint.mdAndUp && currentRoute === '/resultado'"
      class="container my-md-0 py-md-0"
    >
      <v-row
        no-gutters
        cols="12"
        justify-sm="space-around"
        justify-md="space-between"
        aling-md="center"
        class="flex-column flex-sm-row mt-md-2 mb-md-n3"
      >
        <!-- Ciudad -->

        <v-col cols="12" md="4" sm="12">
          <v-autocomplete
            v-if="showSelectsFilter"
            v-model="ciudadeseventosFilter"
            :items="ciudadeseventos"
            outlined
            prepend-inner-icon="location_searching"
            item-text="descripcion"
            item-value="id"
            multiple
            small-chips
            label="Ciudad"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip small v-if="index === 0">
                <span>{{ item.descripcion }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ ciudadeseventosFilter.length - 1 }} ciudades)
              </span>
            </template>
          </v-autocomplete>
        </v-col>
        <!-- Fechas -->
        <v-col cols="12" md="3" sm="12">
          <v-menu
            ref="menu"
            v-model="menu"
            :return-value.sync="desde"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            max-width="360"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="desde"
                readonly
                chips
                small-chips
                label="Fecha"
                placeholder="Todas las fechas"
                prepend-inner-icon="event"
                outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              header-color="primary"
              v-model="desde"
              show-adjacent-months
              scrollable
              full-width
              locale="es-ES"
              range
            >
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-btn text large color="primary" @click="modal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  large
                  color="primary"
                  @click="$refs.menu.save(desde)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-date-picker>
          </v-menu>
        </v-col>
        <!-- Barra de busqueda -->
        <v-col cols="12" md="3" sm="12">
          <v-autocomplete
            v-if="showSelectsFilter"
            v-model="tiposEventosFilter"
            :items="flatItems"
            hide-details
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            item-text="nombre"
            item-value="id"
            placeholder="Buscar por artista o evento..."
            label="Buscar por artista o evento..."
          >
            <!-- Slot para las selecciones -->
            <template v-slot:selection="{ item, index }">
              <v-chip :key="index" small @click:close="remove(item)">
                {{ item.nombre }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <!-- Boton de busqueda -->
        <v-col cols="12" md="1" sm="12">
          <v-btn
            block
            rounded
            class="primary font-weight-medium"
            @click="filterEventos(1)"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <!-- Filtro Escritorio  Inicio-->
    <div
      v-if="currentRoute != '/resultado'"
      class="container d-flex justify-center align-center"
    >
      <v-row
        no-gutters
        cols="12"
        justify-sm="space-around"
        justify-md="space-around"
        aling-md="center"
        class="flex-column flex-sm-row my-sm-4"
      >
        <!-- Ciudad -->

        <v-col cols="12" md="4" class="d-flex justify-center align-center mt-4">
          <v-select
            hide-details
            v-if="showSelectsFilter"
            v-model="ciudadeseventosFilter"
            :items="ciudadeseventos"
            outlined
            small-chips
            prepend-inner-icon="location_searching"
            item-text="descripcion"
            item-value="id"
            label="Ciudad"
          >
          </v-select>
        </v-col>

        <!-- Fechas -->

        <v-col cols="12" md="3" class="d-flex justify-center align-center mt-4">
          <v-menu
            ref="menu"
            v-model="menu"
            :return-value.sync="desde"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            max-width="360"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                hide-details
                readonly
                v-model="desde"
                label="Fecha"
                placeholder="Todas las fechas"
                prepend-inner-icon="event"
                outlined
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              header-color="primary"
              v-model="desde"
              show-adjacent-months
              scrollable
              full-width
              locale="es-ES"
              range
            >
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-btn text large color="primary" @click="modal = false"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  large
                  color="primary"
                  @click="$refs.menu.save(desde)"
                  >OK</v-btn
                >
              </v-card-actions>
            </v-date-picker>
          </v-menu>
        </v-col>

        <!-- Barra de busqueda cambio nuevo-->

        <v-col cols="12" md="3" class="d-flex justify-center align-center mt-4">
          <v-autocomplete
            v-if="showSelectsFilter"
            v-model="tiposEventosFilter"
            :items="flatItems"
            hide-details
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            item-text="nombre"
            item-value="id"
            placeholder="Buscar por artista o evento..."
            label="Buscar por artista o evento..."
          >
            <!-- Slot para las selecciones -->
            <template v-slot:selection="{ item, index }">
              <v-chip :key="index" small @click:close="remove(item)">
                {{ item.nombre }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <!-- Boton de busqueda -->
        <v-col cols="12" md="1" class="d-flex justify-center align-center mt-4">
          <v-btn
            large
            block
            rounded
            class="primary font-weight-medium"
            @click="filterEventos(1)"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </section>
</template>
<script>
  import axios from 'axios';
  import { configApi } from '../../api/configApi';
  import { headers } from '../../api/headers';

  export default {
    data() {
      return {
        currentRoute: window.location.pathname,
        trip: {
          name: '',
          location: null,
          start: null,
          end: null,
        },
        direction: 'bottom',
        fling: false,
        top: true,
        right: false,
        bottom: false,
        left: false,
        transition: 'slide-y-reverse-transition',
        closeOnContentClick: false,
        arrayevento: [],
        arraytpevento: [],
        arrayartista: [],
        arraytotal: [],
        arrayselect: [
          {
            header: 'Eventos',
            items: [],
          },
          {
            header: 'Tipos de Eventos',
            items: [],
          },
          {
            header: 'Artistas',
            items: [],
          },
        ],
        ciudades: ['Cúcuta', 'Bogotá', 'Cali'],
        prueba: [],
        tiposEventosFilter: [],
        ciudadeseventos: [],
        ciudadeseventosFilter: [],
        showSelectsFilter: false,
        desde: null,
        hasta: null,
        modal: false,
        menu: false,
        formData: {
          page: null,
          tiposEvento: null,
          fecha_inicio: null,
          fecha_fin: null,
          ciudadeseventos: null,
          filtro: null,
          vista: null,
          opcion: null,
          opcion2: null,
        },
        variableruta: window.location.pathname,
        opcion: [],
      };
    },
    watch: {
      top(val) {
        this.bottom = !val;
      },
      right(val) {
        this.left = !val;
      },
      bottom(val) {
        this.top = !val;
      },
      left(val) {
        this.right = !val;
      },
      $route(to, from) {
        this.currentRoute = window.location.pathname;
      },
    },

    async beforeCreate() {
      this.$store.dispatch('tipoevento/listTipoEvento', 1);
    },
    async created() {
      await axios
        .get(`${configApi.apiUrl}banner_gira`, null, {
          headers: headers,
        })
        .then((response) => {
          this.ciudadeseventos = response.data.vciudadEventos.map((item) => ({
            id: item.id,
            descripcion: item.descripcion,
          }));
        });

      this.arrayevento = this.$store.getters['evento/listEventos'];
      this.arraytpevento = this.$store.getters['tipoevento/listTipoEvento'];
      this.arrayartista = this.$store.getters['artista/listArtistasActive'];

      for (let i = 0; i < this.arrayevento.length; i++) {
        this.arraytotal.push({
          id:
            this.arrayevento[i].id +
            '/' +
            'evento' +
            '/' +
            this.arrayevento[i].nombre,
          nombre: this.arrayevento[i].nombre,
        });
        this.arrayselect[0].items.push({
          id:
            this.arrayevento[i].id +
            '/' +
            'evento' +
            '/' +
            this.arrayevento[i].nombre,
          nombre: this.arrayevento[i].nombre,
        });
      }
      for (let i = 0; i < this.arraytpevento.length; i++) {
        this.arraytotal.push({
          id:
            this.arraytpevento[i].id +
            '/' +
            'tipoevento' +
            '/' +
            this.arraytpevento[i].nombre,
          nombre: this.arraytpevento[i].nombre,
        });
        this.arrayselect[1].items.push({
          id:
            this.arraytpevento[i].id +
            '/' +
            'tipoevento' +
            '/' +
            this.arraytpevento[i].nombre,
          nombre: this.arraytpevento[i].nombre,
        });
      }
      for (let i = 0; i < this.arrayartista.length; i++) {
        this.arraytotal.push({
          id:
            this.arrayartista[i].id +
            '/' +
            'artista' +
            '/' +
            this.arrayartista[i].nombre,
          nombre: this.arrayartista[i].nombre,
        });
        this.arrayselect[2].items.push({
          id:
            this.arrayartista[i].id +
            '/' +
            'artista' +
            '/' +
            this.arrayartista[i].nombre,
          nombre: this.arrayartista[i].nombre,
        });
      }
    },
    mounted() {
      setTimeout(() => {
        this.showSelectsFilter = true;
      }, 500);
    },
    methods: {
      remove(item) {
        const index = this.tiposEventosFilter.indexOf(item);
        if (index >= 0) this.tiposEventosFilter.splice(index, 1);
      },
      logout() {
        this.$store.dispatch('logout');
      },
      showModalLogin() {
        this.$store.commit('showModalLogin', true);
      },
      ///////
      filterEventos(filtro = 0) {
        if (this.tiposEventosFilter != [] && this.tiposEventosFilter != null) {
          if (this.tiposEventosFilter.length > 0) {
            this.opcion = this.tiposEventosFilter.split('/');
            this.formData.opcion = this.opcion[2];
            this.formData.opcion2 = this.opcion[1];
            this.prueba = [];
            this.prueba.push(this.tiposEventosFilter);

            this.tiposEventosFilter = [];
            this.tiposEventosFilter.push(this.prueba[0]);
          }
        }
        if (this.desde != null) {
          if (this.desde[1] != undefined) this.hasta = this.desde[1];

          this.desde = this.desde[0];
        }

        this.formData.page = 1;
        this.formData.ciudadeseventos = this.ciudadeseventosFilter;
        this.formData.fecha_fin = this.hasta;
        this.formData.fecha_inicio = this.desde;
        this.formData.tiposEvento = this.tiposEventosFilter;
        this.formData.filtro = filtro;

        localStorage.setItem('searchQuery', JSON.stringify(this.formData));

        this.ciudadeseventosFilter = [];
        this.tiposEventosFilter = [];
        this.formData.opcion = null;

        if (this.variableruta != '/resultado') {
          this.$router.push({
            name: 'resultado-filtro',
          });
        } else {
          this.$store.dispatch('evento/filterEventos', {
            page: this.formData.page,
            tiposEvento: this.formData.tiposEvento,
            fecha_inicio: this.formData.fecha_inicio,
            fecha_fin: this.formData.fecha_fin,
            ciudadeseventos: this.formData.ciudadeseventos,
            filtro: this.formData.filtro,
          });
        }
      },
      listAllEventos() {
        this.$store.dispatch('evento/filterEventos', {
          page: 1,
          tiposEvento: [],
          fecha_inicio: null,
          fecha_fin: null,
        });
        this.$store.dispatch('evento/filterEventos', {
          tipos_evento: this.tiposEventosFilter,
          fecha_inicio: this.desde,
          fecha_fin: this.hasta,
        });
      },
    },
    computed: {
      usuario() {
        return this.$store.getters['user/dataUserLogged'];
      },
      modalLogin() {
        return this.$store.getters['modalLogin'];
      },
      tiposEventos() {
        return this.$store.getters['tipoevento/listTipoEvento'];
      },
      artistas() {
        return this.$store.getters['artista/listArtistasActive'];
      },
      flatItems() {
        const flatItems = this.arrayselect.reduce((acc, section) => {
          const itemsWithGroup = section.items.map((item) => ({
            ...item,
            group: section.header,
          }));
          return acc.concat(itemsWithGroup);
        }, []);

        const groupedItems = flatItems.reduce((groups, item) => {
          const groupName = item.group;
          if (!groups[groupName]) {
            groups[groupName] = [];
          }
          groups[groupName].push(item);
          return groups;
        }, {});

        const finalArray = [];
        const groupNames = Object.keys(groupedItems);

        groupNames.forEach((groupName, index) => {
          finalArray.push({ header: groupName });

          finalArray.push(...groupedItems[groupName]);

          if (index < groupNames.length - 1) {
            finalArray.push({ divider: true });
          }
        });
        return finalArray;
      },
    },
  };
</script>
<style>
  #create .v-speed-dial {
    position: absolute;
    z-index: 100;
  }

  #create .v-btn--floating {
    position: relative;
  }
  .v-picker_title_btn,
  .v-date-picker-title__date,
  .v-picker_title_btn--active {
    padding: 16px !important;
  }
</style>
